document.addEventListener('DOMContentLoaded', function () {
  const VAT_RATE = 1.20;

  function setVatMode(mode) {
    document.body.setAttribute('data-vat-mode', mode);
    localStorage.setItem('vatMode', mode);

    // Update active state on all VAT switch buttons
    document.querySelectorAll('[data-vat-switch]').forEach(function (vatSwitch) {
      const incBtn = vatSwitch.querySelector('[data-vat-mode="inc"]');
      const exBtn = vatSwitch.querySelector('[data-vat-mode="ex"]');

      if (incBtn) incBtn.classList.toggle('is-active', mode === 'inc');
      if (exBtn) exBtn.classList.toggle('is-active', mode === 'ex');
    });
  }

  // 1. Global Click Listener (Event Delegation)
  // Ensures buttons work even if replaced dynamically by Shopify theme code
  document.addEventListener('click', function (e) {
    const vatBtn = e.target.closest('[data-vat-mode]');
    if (!vatBtn) return;

    const mode = vatBtn.getAttribute('data-vat-mode');
    if (mode) {
      setVatMode(mode);
    }
  });

  // 2. Recalculate Inc VAT price when Shopify updates prices on variant change
  function updateCalculatedPrices() {
    const exPrices = document.querySelectorAll('[data-price-ex-vat]');
    
    exPrices.forEach(function (exContainer) {
      const incContainer = exContainer.parentElement.querySelector('[data-price-inc-vat]');
      if (!incContainer) return;

      // Extract raw digits/amount from ex-VAT container
      const exMoneyEl = exContainer.querySelector('.price-money') || exContainer;
      const rawText = exMoneyEl.innerText.replace(/[^0-9.]/g, '');
      const exPriceValue = parseFloat(rawText);

      if (!isNaN(exPriceValue)) {
        const incPriceValue = (exPriceValue * VAT_RATE).toFixed(2);
        const incMoneyEl = incContainer.querySelector('.price-money') || incContainer;
        
        // Preserve currency symbol if present
        const currencySymbol = exMoneyEl.innerText.replace(/[0-9.,\s]/g, '');
        incMoneyEl.innerHTML = currencySymbol + incPriceValue + ' <span class="vat-label">inc. VAT</span>';
      }
    });
  }

  // 3. MutationObserver: Watch for DOM changes when variants are switched
  const priceContainers = document.querySelectorAll('.price, [data-price-container], .product__price');
  
  if (priceContainers.length > 0) {
    const observer = new MutationObserver(function (mutations) {
      // Re-apply VAT mode and recalculate values on variant changes
      const currentMode = localStorage.getItem('vatMode') || 'inc';
      setVatMode(currentMode);
      
      // Temporarily disconnect to avoid infinite loop when changing text
      observer.disconnect();
      updateCalculatedPrices();
      
      // Reattach observer
      priceContainers.forEach(container => {
        observer.observe(container, { childList: true, subtree: true });
      });
    });

    priceContainers.forEach(container => {
      observer.observe(container, { childList: true, subtree: true });
    });
  }

  // 4. Initial Load Setup
  const savedVatMode = localStorage.getItem('vatMode') || 'inc';
  setVatMode(savedVatMode);
});